export const compatibilityLabels = {
  1: 'Premiere Pro (MOGRT)',
  2: 'After Effects',
  3: 'Premiere Pro',
  4: 'DaVinci Resolve',
  5: 'Drag & Drop',
  6: 'Final Cut Pro',
};

export const compatibilityLabelShortnames = {
  1: 'PP (MOGRT)',
  2: 'After Effects',
  3: 'Premiere Pro',
  4: 'DaVinci Resolve',
  5: 'Drag & Drop',
  6: 'Final Cut Pro',
};
